<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="红包活动编号"
        width="80"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="app_id_text"
        label="公众号名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="bind_time_text"
        label="绑定时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="status_text"
        label="绑定状态"
        width="180"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.status == 2" type="primary" size="mini" @click="unbinding(scope.row.id)">解绑</el-button>
          <el-button v-if="scope.row.status != 2" style="margin-top:10px" type="primary" size="mini" @click="testredenvelopedsw(scope.row)">测试红包</el-button>
          <el-button v-if="scope.row.status == 1" type="primary" size="mini" @click="updatareset(scope.row.id)">刷新</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="测试红包"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="30%"
    >
      <testredenvelope ref="rtewrw" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { actbindedoaslist, ubbindoas, refreshbindingbox } from '@/api/sourceMaterial.js'
import testredenvelope from './testredenvelope.vue'
export default {
  components: {
    PaginationRight,
    testredenvelope
  },
  data() {
    return {
      pageIfon: {
        page: 1,
        pageSize: 10
      },
      total: null,
      tableData: [],
      id: null,
      dialogVisible: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(val) {
      console.log('val', val)
      this.id = val
      this.resultlist()
    },
    async resultlist() {
      const data = await actbindedoaslist({
        ...this.pageIfon,
        red_packet_no: this.id
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    unbinding(id) {
      this.$confirm('确定解绑吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        ubbindoas({
          id: id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.resultlist()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    testredenvelopedsw(item) {
      this.dialogVisible = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.rtewrw.send(item)
      })
    },
    updata() {
      this.dialogVisible = false
      this.resultlist()
    },
    async updatareset(id) {
      const data = await refreshbindingbox({
        id: id
      })
      this.$message({
        type: 'success',
        message: '刷新成功!'
      })
      this.resultlist()
      console.log('data', data)
    }
    // async loojser(item) {
    //   const data = await fetchres({
    //     id: item
    //   })
    //   this.$message({
    //     type: 'success',
    //     message: '刷新成功!'
    //   })
    //   this.resultlist()
    //   console.log('data', data)
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
